module.exports = __webpack_public_path__ + "static/media/googleplay.db9b21a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/googleplay.png
// module id = 850
// module chunks = 0